import React from 'react';

const LocationDetails = ({
                             addressDetails,
                             newPlace,
                             locationicon,
                             HomeStyles,
                             getFormattedDate,
                             getFormattedTime,
                             selectedTimeZone
                         }) => (
    <div className={HomeStyles.location_details_container}>
        <h2 className={HomeStyles.location}>LOCATION</h2>
        <div className={HomeStyles.pickedlocation}>
            <div className={HomeStyles.pickedlocation_new}>
                <img src={locationicon} alt="Location Icon" style={{ width: '16px', marginRight: '8px' }} />
                {addressDetails}
            </div>
            {newPlace && (
                <div className={HomeStyles.pickedlocation_lat_long}>
                    <span>Lat: {newPlace?.lat}</span>
                    <span className={HomeStyles.lng} style={{ marginLeft: '8px' }}>Long: {newPlace?.long}</span>
                </div>
            )}
        </div>
        <div className={HomeStyles.selected_date_time}>
            <span>Date: {getFormattedDate()}</span>
            <span style={{ marginLeft: '10px' }}>Time: {getFormattedTime()} ({selectedTimeZone})</span>
        </div>
    </div>
);

export default LocationDetails;